import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';
const LANG_KEY = 'view-language';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  userAuthEvent: EventEmitter<any> = new EventEmitter();

  constructor() { }

  logout(): void {
    localStorage.clear();
    this.userAuthEvent.emit("logout");
  }

  public saveToken(token: string): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string {
    return localStorage.getItem(TOKEN_KEY);
  }

  public saveUser(user): void {
    localStorage.removeItem(USER_KEY);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    this.userAuthEvent.emit("login");
  }

  public saveLang(lang): void {
    localStorage.removeItem(LANG_KEY);
    localStorage.setItem(LANG_KEY, JSON.stringify(lang));
  }

  public getLang(): any {
    return JSON.parse(localStorage.getItem(LANG_KEY));
  }

  public getUser(): any {
    return JSON.parse(localStorage.getItem(USER_KEY));
  }

  public getUserRoles(): Observable<{roles: string[]}> {
    let user = JSON.parse(localStorage.getItem(USER_KEY));
    return new Observable(observer => {observer.next(user);});
  }

}